import { connect } from 'react-redux';
import { compose } from 'redux';
import { withConfig } from 'shell/hoc/withConfig';
import { withStyles } from '@material-ui/core/styles';
import { withOptimizely } from '@optimizely/react-sdk';
import styles from './Toggles.styles';
import { Toggles } from './Toggles';

const mapStateToProps = ({ user: { data }, userGroups: { activeADGroup } }) => ({
  userId: data.employeeNumber,
  userADGroup: activeADGroup || data.groups[0],
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withOptimizely,
  withConfig(),
)(Toggles);
